import React from 'react'
import { string } from 'prop-types'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import GenericDropdown from '../../generic-dropdown.jsx'
import { FormattedMessage } from 'react-intl'

const CapDatatypeSelect = props => {
  const variables = {}
  const qlq = gql`
    {
      cap_datatypes {
        datatype_uid
        name
        description
        code
        inherited_datatype_uid
        is_scalar
      }
    }
  `
  return (
    <Query query={qlq} variables={variables}>
      {({ loading, error, data, refetch }) => {
        const options =
          data && data.cap_datatypes
            ? data.cap_datatypes.map(v => ({
                ...v,
                value: v.datatype_uid
              }))
            : []
        return (
          <GenericDropdown
            {...props}
            options={options}
            placeholder={
              props.placeholder ? (
                props.placeholder
              ) : (
                <FormattedMessage
                  id="crm.ui.dropdown.select_datatype"
                  defaultMessage="Select Datatype"
                />
              )
            }
          />
        )
      }}
    </Query>
  )
}

CapDatatypeSelect.propTypes = {
  accountUid: string.isRequired,
  placeholder: string
}

export default CapDatatypeSelect
